import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { V2Notifikation, V2NotifikationType } from '../../store/models';
import { V2NotifikationModalStore } from './v2-notifikation-modal.store';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 'app-v2-notifikation-modal',
    templateUrl: './v2-notifikation-modal.component.html',
    providers: [V2NotifikationModalStore],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class V2NotifikationModalComponent implements OnInit {
    @Input() notifikationType: V2NotifikationType;
    v2Notifikationer$ = this.v2NotifikationModalStore.v2Notifikationer$;

    get modalTitle() {
        switch (this.notifikationType) {
            case V2NotifikationType.KundeacceptGodkendt:
                return 'Kundeaccept godkendt af LA';
            case V2NotifikationType.TilpasHandlingerGodkendt:
                return 'Tilpas handlinger godkendt af LA';
            case V2NotifikationType.SagKonklusionGodkendt:
                return 'Sager godkendt af LA';
            case V2NotifikationType.SagKonklusionGodkendtReviewpartner:
                return 'Sager godkendt af Reviewpartner';
            case V2NotifikationType.SagKonklusionGodkendtSOP:
                return 'Sager godkendt af SOP';
        }
    }

    get hasSag() {
        return this.notifikationType !== V2NotifikationType.KundeacceptGodkendt;
    }

    constructor(
        private readonly v2NotifikationModalStore: V2NotifikationModalStore,
        private modal: NgbActiveModal,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.v2NotifikationModalStore.loadV2Notifikationer(this.notifikationType);
    }

    trackById(_: number, v2Notifikation: V2Notifikation) {
        return v2Notifikation.id;
    }

    onDismiss() {
        this.modal.dismiss();
    }

    onSeen(event: Event, id: number) {
        event.stopPropagation();
        event.preventDefault();
        this.v2NotifikationModalStore.deleteV2Notifikation(id);
    }

    async navigateToAction(notifikation: V2Notifikation) {
        let navigation: any[];
        switch (notifikation.type) {
            case V2NotifikationType.KundeacceptGodkendt:
                navigation = ['/clients', notifikation.kid, 'regnskabsaar', notifikation.regnskabsaarId];
                break;
            case V2NotifikationType.TilpasHandlingerGodkendt:
            case V2NotifikationType.SagKonklusionGodkendt:
            case V2NotifikationType.SagKonklusionGodkendtReviewpartner:
            case V2NotifikationType.SagKonklusionGodkendtSOP:
                navigation = ['/clients', notifikation.kid, 'udfoer', 'regnskabsaar', notifikation.regnskabsaarId, 'sag', notifikation.sagId];
                break;
        }
        await this.router.navigate(navigation);
        this.modal.dismiss();
    }
}
